import React from 'react';

function About() {
  return (
    <section id="about" className="bg-white py-8 md:py-12">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-brand-900 text-center mb-4">
          About Anders Ponds & Lakes
        </h2>
        <p className="text-xl text-brand-700 text-center mb-12 max-w-2xl mx-auto">
          Dedicated to preserving Florida's freshwater ecosystems
        </p>

        <div className="max-w-4xl mx-auto space-y-12">
          {/* Mission Statement */}
          <div className="bg-white rounded-lg p-6 md:p-8 shadow-md border-l-4 border-water-500">
            <h3 className="text-2xl font-bold text-brand-900 mb-4">Our Mission</h3>
            <p className="text-slate-700 leading-relaxed text-lg">
              At Anders Ponds & Lakes, we are committed to the preservation and responsible
              management of freshwater ecosystems throughout Florida. We believe that healthy
              ponds and lakes are vital to our environment, property values, and quality of life.
              Our goal is to provide effective, environmentally-conscious solutions that maintain
              the natural beauty and ecological balance of your water features.
            </p>
          </div>

          {/* Why Aquatic Management Matters */}
          <div className="bg-white rounded-lg p-6 md:p-8 shadow-md">
            <h3 className="text-2xl font-bold text-brand-900 mb-4">
              Why Aquatic Management Matters
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <h4 className="font-bold text-brand-800 mb-2">Environmental Benefits</h4>
                <ul className="text-slate-700 space-y-2">
                  <li className="flex items-start">
                    <span className="text-nature-500 mr-2">✓</span>
                    Maintains healthy fish and wildlife habitats
                  </li>
                  <li className="flex items-start">
                    <span className="text-nature-500 mr-2">✓</span>
                    Prevents harmful algae blooms
                  </li>
                  <li className="flex items-start">
                    <span className="text-nature-500 mr-2">✓</span>
                    Protects water quality for surrounding areas
                  </li>
                  <li className="flex items-start">
                    <span className="text-nature-500 mr-2">✓</span>
                    Supports native plant and animal species
                  </li>
                </ul>
              </div>
              <div>
                <h4 className="font-bold text-brand-800 mb-2">Property Benefits</h4>
                <ul className="text-slate-700 space-y-2">
                  <li className="flex items-start">
                    <span className="text-nature-500 mr-2">✓</span>
                    Increases property values
                  </li>
                  <li className="flex items-start">
                    <span className="text-nature-500 mr-2">✓</span>
                    Enhances aesthetic appeal
                  </li>
                  <li className="flex items-start">
                    <span className="text-nature-500 mr-2">✓</span>
                    Reduces mosquito breeding areas
                  </li>
                  <li className="flex items-start">
                    <span className="text-nature-500 mr-2">✓</span>
                    Prevents costly emergency repairs
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Credentials */}
          <div className="bg-brand-800 text-white rounded-lg p-6 md:p-8 shadow-md">
            <h3 className="text-2xl font-bold mb-4">Our Credentials</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
              <div>
                <div className="text-3xl mb-2">🏛️</div>
                <h4 className="font-bold mb-1">Licensed</h4>
                <p className="text-brand-200 text-sm">
                  Florida Department of Agriculture
                </p>
              </div>
              <div>
                <div className="text-3xl mb-2">🛡️</div>
                <h4 className="font-bold mb-1">Fully Insured</h4>
                <p className="text-brand-200 text-sm">
                  Comprehensive liability coverage
                </p>
              </div>
              <div>
                <div className="text-3xl mb-2">📚</div>
                <h4 className="font-bold mb-1">Continuing Education</h4>
                <p className="text-brand-200 text-sm">
                  Up-to-date on latest methods
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
